// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { getErrorSelector } from '@tcp/core/src/utils/utils.extension';
import { POINTS_CLAIM_REDUCER_KEY } from '../../../../../constants/reducer.constants';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
} from '../../../../../utils/labels/labelUtilty';
import labelsObj, {
  ACCOUNT_MYPLACE_REWARDS,
  lblPointsClaimErrorInternal,
  lblPointsClainError,
} from '../PointsClaim.labels';

const getState = (state) => state[POINTS_CLAIM_REDUCER_KEY];

/**
 * Selector function to return redux error
 * @param { object } state reduxStore state
 */
export const getError = createSelector(getState, (state) => state && state.get('error'));

/**
 * Selector function to return redux success
 * @param { object } state reduxStore state
 */
export const getSuccess = createSelector(getState, (state) => state && state.get('success'));

/**
 * Selector function to return redux showNotification
 * @param { object } state reduxStore state
 */
export const getShowNotificationState = createSelector(
  getState,
  (resp) => resp && resp.get('showNotification')
);

/**
 * Selector function to return redux errormessage
 * @param { object } state reduxStore state
 */
export const getPointsClaimErrorMessage = createSelector(getError, (state) => {
  const labels = {
    [lblPointsClaimErrorInternal]: getLabelFromCopyOrFromTranslation(
      `${ACCOUNT_MYPLACE_REWARDS}.${lblPointsClaimErrorInternal}`,
      labelsObj
    ),
    [lblPointsClainError]: getDynamicLabelValues(
      `${ACCOUNT_MYPLACE_REWARDS}.${lblPointsClainError}`
    ),
  };
  return getErrorSelector(state, labels, 'lbl_points_claim_error');
});
